export { default as PartnerCard } from './PartnerCard';
export type { PartnerCardModel, PartnerCardProps } from './PartnerCard';
